import * as R from 'ramda';

export default function SyncAssetConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmSync = _handleConfirmSync;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmSync($event) {
    loaderService.showViewLoader = true;
    const assetIds = [];
    const syncDTO = {
      customerId: assetDataService.customerId,
      customerAssetTypeId: vm.assetType.customerAssetTypeId,
      syncAllCustomerAssets: false,
      syncAllCustomerAssetsForAssetType: false,
      customerAssetIds: assetIds,
    };
    if (!vm.isMultipleAssets) {
      assetIds.push(vm.asset.customerAssetId);
      syncDTO.customerAssetIds = assetIds;
    } else {
      R.forEach(
        (item) => {
          assetIds.push(item.customerAssetId);
        },
        vm.assets
      );
      syncDTO.customerAssetIds = assetIds;
    }
    return assetDataService.syncAsset(syncDTO)
      .then(() => {
        if (!vm.isMultipleAssets) {
          alerts.success(`The asset "${vm.asset.name}" was successfully synced.`);
        } else {
          alerts.success('The assets were successfully synced.');
        }
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while syncing the asset.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.syncAssetDialog);
  }
}

SyncAssetConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
